import { environment } from "../config/environment";
import { fetchJson } from "../../fetch";

export interface RecommendedGames {
  games?: string[];
  analyticsURLParam?: string;
}

export class RecommendedGameService {
  static async getRecommendedGames(): Promise<RecommendedGames> {
    return fetchJson(
      `${environment.AARP_CONST_BLOB}/${environment.AARP_ENV}/json/RecommendedGames.json`,
      { timeout: 10 * 1000 }
    ).catch((err) => {
      console.error(err);
      return { games: [], analyticsURLParam: "" };
    });
  }
}
